/**
 * Format a booking lead-time value (in minutes) into a German label like
 * "60 Minuten", "2 Stunden", "3 Tage". Used by the booking-flow components
 * and the shared LeadTimeNoticeComponent.
 */
export function formatLeadTime(minutes: number): string {
  if (minutes >= 1440 && minutes % 1440 === 0) {
    const days = minutes / 1440;
    return days === 1 ? '1 Tag' : `${days} Tage`;
  }
  if (minutes >= 60 && minutes % 60 === 0) {
    const hours = minutes / 60;
    return hours === 1 ? '1 Stunde' : `${hours} Stunden`;
  }
  return `${minutes} Minuten`;
}

/** Tooltip shown on greyed-out slots and grid cells outside the window. */
export function leadTimeTooltipText(minutes: number): string {
  return `Erst max. ${formatLeadTime(minutes)} im Voraus buchbar`;
}

/** Toast shown when the user clicks an out-of-window slot or grid cell. */
export function leadTimeBlockedToastText(minutes: number): string {
  return `Diese Zeit ist noch nicht buchbar. Buchungen sind max. ${formatLeadTime(minutes)} im Voraus möglich.`;
}
